<span class="slick-id">
    <ng-container *ngIf="value; else emptyValue">

        <ng-container *ngIf="!routerLink">
           <span [matTooltip]="value"
                 [matTooltipClass]="'font-size-13'"
                 [matTooltipDisabled]="disableTooltip || !hasSlickId"
                 [matTooltipShowDelay]="500"
                 class="slickid-value"
           >
                {{slickIdValue}}
            </span>
        </ng-container>

        <ng-container *ngIf="routerLink">
             <a [matTooltip]="value"
                [matTooltipClass]="'font-size-13'"
                [matTooltipDisabled]="disableTooltip || !hasSlickId"
                [matTooltipShowDelay]="500"
                class="slickid-value"
                [routerLink]="routerLink"
                routerLinkActive="active"
             >
                {{slickIdValue}}
            </a>
        </ng-container>

        <a *ngIf="allowCopy" ngxClipboard
           [cbContent]="value"
           (cbOnSuccess)="onCopy()"
           (click)="$event.stopPropagation()"
           class="copy-str-btn" matTooltip="Copy" aria-hidden="true">
            <mat-icon>content_copy</mat-icon>
        </a>
    </ng-container>

    <ng-template #emptyValue>
        <span class="hint-text">{{naTitle ? naTitle : 'n/a'}}</span>
    </ng-template>
</span>

